import React from 'react';
import PageTitle from '../../layouts/PageTitle';

const OrderDetails = () => {
    return (
        <div className='reportorderDetails'>

            <PageTitle
                title="Reports"
                subtitle="Order Details"
            />

            <div className='date_select'>
                <select className='border-0' name="week" id="week" style={{ width: '60px' }}>
                    <option value="" selected>Today</option>
                    <option value="">Yesterday</option>
                    <option value="">This week</option>
                    <option value="">Last week</option>
                    <option value="">Custom</option>
                </select>
            </div>

            <div className="card  rounded-0 mt-2">
                <div className='card-header top-portion px-0'>
                    <div className="row w-100 m-0">
                        <div className="col-md-6 col-lg-6">
                            <h3>Order Details</h3>
                        </div>
                        <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                            <i className="mdi mdi-download mdi-24px"></i>
                            <i className="mdi mdi-send ml-3"></i>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <ul>
                        <li> <b>Download the report as a csv to see all details of your orders</b></li>
                        <li className='fs-1'> 242</li>
                        <li>Orders</li>
                    </ul>
                </div>
            </div>

            <div className="row mt-5">
                <span className=''>Disclaimer. Please note that the reports present raw and unconditioned order data. Revenues include onlyfood values(excluding discounts, delivery fees, etc).Final settlements can be from the invoice</span>
            </div>


        </div>
    );
};

export default OrderDetails;